import React, {useEffect, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'

const AudiochatPlugin = () => {
  const [configID, setConfigId] = useState(0)
  const [audioCallConfig, setAudioCallConfig] = useState<any>({
    isAudioCallEnabled: true,
    creditPerMin: 1,
    isCreditDeduct: true,
    isTransferCredit: true,
    transferCreditPercentage: 100,
    deductCreditGender: 1,
    verifiedUserOnlyCreate: false,
   
  })

  useEffect(() => {
    getConfiguration()
  }, [])

  const handleChange = (event: any) => {
    let name = event.target.name
    let value = event.target.checked

    if (
      name === 'creditPerMin' ||
      name === 'transferCreditPercentage' 
    ) {
      setAudioCallConfig({...audioCallConfig, [name]: event.target.value})
    } else {
      if (name === 'deductCreditGender') {
        setAudioCallConfig({...audioCallConfig, [name]: event.target.value})
        updateConfiguration({...audioCallConfig, [name]: event.target.value})
      } else {
        setAudioCallConfig({...audioCallConfig, [name]: value})
        updateConfiguration({...audioCallConfig, [name]: value})
      }
    }
  }

  const [isProfileVerificationEnabled, setIsProfileVerificationEnabled] = useState(true);

  const getConfiguration = async () => {
    let verificationResult = await getConfigurationByName('verification')
    if (verificationResult.success && verificationResult.data) {
      let parsedVerification = JSON.parse(verificationResult.data.values)
      setIsProfileVerificationEnabled(parsedVerification.isEnable)
    }

    let result = await getConfigurationByName('audiochat')
    if (result.success) {
      let parsedData = JSON.parse(result.data.values)
      setConfigId(result.data.id)
      setAudioCallConfig({
        isAudioCallEnabled: parsedData?.isAudioCallEnabled,
        creditPerMin: parsedData?.creditPerMin,
        isCreditDeduct: parsedData?.isCreditDeduct,
        isTransferCredit: parsedData?.isTransferCredit,
        transferCreditPercentage: parsedData?.transferCreditPercentage,
        deductCreditGender: parsedData?.deductCreditGender,
        verifiedUserOnlyCreate: parsedData?.verifiedUserOnlyCreate,
       
      })
    }
  }

  const onBlurUpdate = () => {
    updateConfiguration(audioCallConfig)
  }

  const updateConfiguration = async (config: any) => {
    let result = await updateConfigurationByConfigID(configID, config, null)
    if (result.success) {
      getConfiguration()
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  return (
    <div className='card'>
      <div className='card-body'>
        <div className='row no-gutters'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable Audio Calling</strong>
            </p>
            <p className='text-muted'>Enable or disable Audio Calling for the software</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='isAudioCallEnabled'
                checked={audioCallConfig.isAudioCallEnabled}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Verified User Can Only audio call</strong>
            </p>
            <p className='text-muted'>
              By default, audio calls are only available to all users. To allow Verified users to
              start an audio call, enable this feature for them.
            </p>
            {!isProfileVerificationEnabled && (
              <p className='text-danger mt-2' style={{fontSize: '0.85rem'}}>
                You have to start profile verification system in verification plugins to use this feature.
              </p>
            )}
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='verifiedUserOnlyCreate'
                checked={isProfileVerificationEnabled && audioCallConfig.verifiedUserOnlyCreate}
                onChange={(event) => handleChange(event)}
                disabled={!isProfileVerificationEnabled}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable credits per minute</strong>
            </p>
            <p className='text-muted'>
              Charge specific amount of credits per minute on the audiocalling
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='isCreditDeduct'
                checked={audioCallConfig.isCreditDeduct}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Charge credits per minutes</strong>
            </p>
            <p className='text-muted'>
              Audiocalling requires credits per minutes for work, the credits will be charged only
              to the caller user
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <label className='form-check-label' htmlFor='flexSwitchCheckDefault'>
                Amount Of Coins
              </label>
              <input
                type='number'
                className='form-control'
                name='creditPerMin'
                value={audioCallConfig.creditPerMin}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
                disabled={!audioCallConfig.isCreditDeduct}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Charge credits to specific gender</strong>
            </p>
            <p className='text-muted'>Charge credits per call only to the selected gender</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <label htmlFor='creditsPerMessageGender'>Charge credits gender</label>
              <br />
              <select
                className='form-select form-select-solid fw-bolder'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                data-kt-user-table-filter='gender'
                data-hide-search='true'
                defaultValue={audioCallConfig.deductCreditGender}
                name='deductCreditGender'
                value={audioCallConfig.deductCreditGender}
                onChange={(event) => handleChange(event)}
              >
                <option value={1}>Male</option>
                <option value={2}>Female</option>
              </select>
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Transfer audiocall credits</strong>
            </p>
            <p className='text-muted'>
              Transfer to the called user the spent credits by the caller user
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='isTransferCredit'
                checked={audioCallConfig.isTransferCredit}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Transfer Coins Percentage</strong>
            </p>
            <p className='text-muted'>
              Its Transfer Only That Percentage which You Have Entered Here
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <label className='form-check-label' htmlFor='flexSwitchCheckDefault'>
                Coins Percentage
              </label>
              <input
                type='number'
                className='form-control'
                name='transferCreditPercentage'
                value={audioCallConfig.transferCreditPercentage}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
                disabled={!audioCallConfig.isTransferCredit}
              />
            </div>
          </div>

         
          
        </div>
      </div>
    </div>
  )
}

export default AudiochatPlugin
